<template>
    <button
        class="transparentButton"
        type="button"
        :disabled="disabled"
        @click="handleClick"
    >
        <span>
            <img :src="iconSrc" :alt="altText" class="buttonIcon" />
            <div
                v-if="label"
                class="buttonText"
                style="font-size:12px"
            >
                {{ label }}
            </div>
        </span>
    </button>
</template>

<script>
export default {
    name: 'TransparentButton',
    props: {
        iconSrc: {
            type: String,
            required: true,
        },
        label: {
            type: String,
            default: '',
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        altText: {
            type: String,
            default: undefined,
        },
    },
    computed: {
        fontSizeS() {
            // 例: CSS_FONTSIZE.S が "12px" のような文字列を想定
            return CSS_FONTSIZE.S
        },
    },
    methods: {
        handleClick() {
            this.$emit('click')
        },
    },
}
</script>

<style scoped>
.transparentButton {
    display: block;
    cursor: pointer;
    outline: 0;
    background-color: transparent;
    border-style: none;
}

.buttonIcon {
    height: 18px;
    vertical-align: middle;
}

.buttonText {
    display: inline-block;
    padding-left: 5px;
    color: #5171cb;
}

button:disabled {
    cursor: not-allowed;
    opacity: 0.6;
}

button:not(:disabled):hover {
    opacity: 0.7;
}

button:disabled:focus,
button:disabled:focus-visible {
    outline: none;
}
</style>
